import { Link } from 'react-router-dom';

const GoToHomePage = ({ classNames, link }) => {
  return (
    <Link to={link ?? '/'} className={`go-to-homepage ${classNames}`}>
      <div className='go-to-homepage__background' />
    </Link>
  );
};

export default GoToHomePage;
